import { render, staticRenderFns } from "./alliancesDetail.vue?vue&type=template&id=6fe0b132&scoped=true&"
import script from "./alliancesDetail.vue?vue&type=script&lang=js&"
export * from "./alliancesDetail.vue?vue&type=script&lang=js&"
import style0 from "./alliancesDetail.vue?vue&type=style&index=0&id=6fe0b132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe0b132",
  null
  
)

export default component.exports